<template>
  <div class="courseitem">
    <div class="head-wrap">
      <div class="head-video">
        <div class="videos">
          <div class="singles-video" id="singlesVideo">
            <img :src="GLOBAL.BASE_URL+course.thum" alt />
          </div>
        </div>
        <div class="item">
          <p class="name">{{course.name}}</p>
          <p class="name">
            <el-rate
              v-model="value"
              disabled
              show-score
              text-color="orange"
              score-template="{value}"
            ></el-rate>
          </p>

          <p class="data">
            <span>所属专业：{{course.category.category_name}}</span>
            <span>推荐完成时间：{{course.times}}分钟</span>
            <span>类型：{{courseType[course.type]}}</span>
            <span>{{course.user_count}}学习过此系统</span>

            <!-- <span class="price" v-if="course.description"><span class="sp2">{{ course.description}}</span></p> -->
          </p>
          <div class="bottom">
            <p class="btns">
              <button class="btn1"   @click="goLearn(course.url)" v-if="course.status==0">进入实验</button>
              <button class="btn1s" @click="goopen()" v-else>
                <i class="el-icon-lock"></i>进入实验
              </button>
              <!--              <button   class="btn2">免费试学</button>-->
              <!-- <el-button type="info" icon="el-icon-lock"> 进入实验</el-button> -->
            </p>
          </div>
        </div>
      </div>
      <div class style="width:1000px;margin:0 auto;" v-html="course.description"></div>
    </div>

    <!--    <div class="tab">-->
    <!--      <ul>-->
    <!--        <el-tabs v-model="activeName" type="card">-->
    <!--          <el-tab-pane label="项目描述" name="first">-->
    <!--            <div>-->
    <!--              {{course.description}}-->
    <!--            </div>-->
    <!--          </el-tab-pane>-->
    <!--          <el-tab-pane label="实验目的" name="second">-->
    <!--            <div>-->
    <!--              {{course.description}}-->
    <!--            </div>-->
    <!--          </el-tab-pane>-->
    <!--          <el-tab-pane label="实验原理" name="third">-->
    <!--            <div>-->
    <!--              {{course.description}}-->
    <!--            </div>-->
    <!--          </el-tab-pane>-->
    <!--          <el-tab-pane label="实验器材" name="four">-->
    <!--            <div>-->
    <!--              {{course.description}}-->
    <!--            </div>-->
    <!--          </el-tab-pane>-->
    <!--          <el-tab-pane label="实验方法与步骤" name="five">-->
    <!--            <div>-->
    <!--              {{course.description}}-->
    <!--            </div>-->
    <!--          </el-tab-pane>-->
    <!--          <el-tab-pane label="考核要求" name="six">-->
    <!--            <div>-->
    <!--              {{course.description}}-->
    <!--            </div>-->
    <!--          </el-tab-pane>-->
    <!--        </el-tabs>-->
    <!--      </ul>-->
    <!--    </div>-->
    <el-dialog
      :title="course.name"
      :visible.sync="centerDialogVisible"
      @close="onCloseHandel"
      :center="true"
      width="95%"
      top="10px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :destroy-on-close="true"
      :fullscreen="true"
    >
      <div class="dialog-footer" style="text-align: right">
        <el-button type="info" style="width: 100%" @click="beforeCloseHandle">关闭窗口</el-button>
      </div>
      <iframe
        id="iframe"
        :src="iframeSrc"
        frameborder="0"
        width="100%"
        height="1000px"
        allowfullscreen="true"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CourseDetail",
  data() {
    return {
      courseType: ["在线训练", "模型", "智能设备"],
      course: {
        category: ""
      },
      show: false,
      activeName: "first",
      value: 5.0,
      centerDialogVisible: false,
      iframeSrc: "",
      code:'',
      isdisabled:false,
    };
  },
  created(){
this.getsjCode()
console.log(this.$route.params.detailId)
  },
  methods: {

    onCloseHandel() {
      this.$router.push({ name: "practices" });
    },
    beforeCloseHandle() {
      this.$confirm("关闭窗口前请确认是否完成训练, 是否继续?", "提示", {
        confirmButtonText: "关闭窗口",
        cancelButtonText: "继续训练",
        type: "warning"
      }).then(() => {
        this.onCloseHandel();
      });
    },
    afterEnter() {
      this.show = false;
    },

    // 获取课程详情
    getCourse() {
      this.$http
        .courseAllList({ id: this.$route.params.detailId })
        .then(res => {
          if (res.code !== 0) {
            this.course = res.data.learn[0];
          } else {
            this.$message.error(res.message);
          }
        });
    },
    //获取随机码
     getsjCode() {
      this.$http
        .getsjCode()
        .then(res => {
          if (res.code == 200) {
            this.code=res.data
          } else {
            this.$message.error(res.message);
          }
        });
    },
    goLearn(url) {
      if (url) {
        if (this.$cookies.get("token")) {
          // this.centerDialogVisible=true;
          // this.iframeSrc=url + '?user_id=' + this.$store.getters.getUserInfo.id
          // window.location.href=(url + '?user_id=' + this.$store.getters.getUserInfo.id);

// return;
          var baseurl = this.GLOBAL.BASE_URL;
          window.location.href =
            url +
            "?user_id=" +
            this.$store.getters.getUserInfo.id +
            "+" +
            baseurl+"+"+this.code+"+"+this.$route.params.detailId;


        } else this.$router.push({ name: "Login" });
      } else this.$message("暂未开放");
    },
    goopen() {
      this.$message({
        message: "未授权不能进入实验哦",
        type: "warning"
      });
    }
  },
  mounted() {
    this.getCourse();
  }
};
</script>

<style>
button {
  border: 0;
  outline: 0;
}

.singles-video .prism-info-display {
  z-index: 1 !important;
}

.singles-video .prism-big-play-btn {
  position: absolute;
  left: 50% !important;
  bottom: 50% !important;
  margin-left: -31.5px !important;
  margin-bottom: -31.5px !important;
  cursor: pointer !important;
  z-index: 2 !important;
}

.courseitem {
  width: 100%;
  height: auto;
  background: #fff;
  overflow-x: hidden;
}

.courseitem .head-wrap {
  width: 100%;
  height: auto;
  background: #fff;
  padding-top: 30px;
  /* background: -moz-linear-gradient(top, #e9e9e9 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #e9e9e9), color-stop(100%, #ffffff));
    background: -webkit-linear-gradient(top, #e9e9e9 0%, #ffffff 100%);
    background: -o-linear-gradient(top, #e9e9e9 0%, #ffffff 100%);
    background: -ms-linear-gradient(top, #e9e9e9 0%, #ffffff 100%);
    background: linear-gradient(to bottom, #e9e9e9 0%, #ffffff 100%); */
}

.courseitem .head-wrap .head-video {
  width: 1200px;
  height: auto;
  display: flex;
  margin: 0 auto;
}

.courseitem .head-wrap .head-video .videos {
  /* width: 630px;
    height: 350px; */
    width:30%;
}

.courseitem .head-wrap .head-video .videos div {
  width: 100%;
  height: 100%;
}
.singles-video img {
  width: 100%;
  height: 100%;
}

.courseitem .head-wrap .head-video .item {
  flex: 1;
  position: relative;
}

.courseitem .head-wrap .head-video .item .name {
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #333333;
  padding: 10px 23px;
  letter-spacing: 0.45px;
  padding-bottom: 0;
}

.courseitem .head-wrap .head-video .item .data {
  padding-left: 23px;
  padding-right: 23px;
  padding-bottom: 10px;
  padding-top: 10px;
  font-size: 14px;
  color: #9b9b9b;
  font-family: PingFangSC-Light;
}

.courseitem .head-wrap .head-video .item .data > span {
  margin-right: 15px;
}

.courseitem .head-wrap .head-video .item .preferential {
  width: 100%;
  height: auto;
  background: #fa6240;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #4a4a4a;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 23px;
}

.courseitem .head-wrap .head-video .item .preferential p:nth-of-type(1) {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0.36px;
}

.courseitem .head-wrap .head-video .item .preferential p:nth-of-type(2) {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ffffff;
}

.courseitem .head-wrap .head-video .item .preferential p:nth-of-type(2) span {
  width: 24px;
  height: auto;
  display: inline-block;
  background: #fafafa;
  color: #5e5e5e;
  padding: 6px 0;
  text-align: center;
}

.courseitem .head-wrap .head-video .item .price {
  width: 100%;
  height: auto;
  background: #f9f1e7;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #4a4a4a;
  display: flex;
  align-items: flex-end;
  padding: 5px 23px;
}

.courseitem .head-wrap .head-video .item .price .sp1 {
  font-size: 26px;
  color: #fa6240;
  margin-left: 10px;
  display: inline-block;
  margin-bottom: -5px;
}

.courseitem .head-wrap .head-video .item .price .sp2 {
  font-size: 14px;
  color: #9b9b9b;
  margin-left: 10px;
}

.courseitem .head-wrap .head-video .item .bac {
  background: #fff;
}

.courseitem .head-wrap .head-video .item .bottom {
  position: absolute;
  left: 0;
  bottom: 10px;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 23px;
  padding-right: 23px;
}

.courseitem .head-wrap .head-video .item .bottom .btns {
  display: flex;
  align-items: center;
}

.courseitem .head-wrap .head-video .item .bottom .btns button {
  width: 78px;
  height: 30px;
  background: #f5a623;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  margin-right: 15px;
}
.courseitem .head-wrap .head-video .item .bottom .btns .btn1s {
  width: 78px;
  height: 30px;
  background: #d8d8d8;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  margin-right: 15px;
}

.courseitem .head-wrap .head-video .item .bottom .btns .btn2 {
  background: #fff;
  color: #f3a536;
  border: 1px solid #f3a536;
}

.courseitem .head-wrap .head-video .item .bottom .add img {
  width: 20px;
  height: auto;
  cursor: pointer;
}

.courseitem .tab {
  width: 100%;
  height: auto;
  background: #fff;
  margin-top: 30px;
}

.courseitem .tab ul {
  width: 1200px;
  height: auto;
  display: flex;
  align-items: center;
  margin: 0 auto;
  color: #4a4a4a;
  font-family: PingFangSC-Regular;
}

.courseitem .tab ul li {
  margin-right: 15px;
  padding-top: 26px;
  padding-bottom: 16px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 17px;
  cursor: pointer;
}

.courseitem .tab ul li span {
  color: #fb7c55;
}

.courseitem .this {
  color: #f5a623;
  border-bottom: 2px solid #f5a623;
}

.courseitem .this span {
  color: #f5a623 !important;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

/*.bounce-leave-active {
    animation: bounce-in .5s reverse;
  }*/
@keyframes bounce-in {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, -50px);
  }
}

p.add {
  position: relative;
}

p.active {
  color: #d38600;
  font-size: 20px;
  font-weight: 500;
  position: absolute;
  top: -5px;
  left: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/Course/CourseDetail.vue